import React, { Component } from 'react';
import Loader from "../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import Footer from "../../../common_components/Footer";
import Header from "../../../common_components/Header";
import { withRouter } from "../../../utils/withRouter";
import Modal from 'react-bootstrap/Modal';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Resizer from "react-image-file-resizer";
import {
    contactNoValidator,
    panNoValidator,
    tanNoValidator,
    gstNoValidator,
    emailValidator,
} from "../../../utils/Validator";
import ReactDOM from 'react-dom';
import { Carousel } from 'react-responsive-carousel'
// import styles from 'react-responsive-carousel/lib/styles/carousel.min.css'
import { connect } from "react-redux";
import { toastError, toastSuccess, DOC_BASE_URL, countryActionId, gstValidationListActionId, businessSectorActionId, primaryServicesActionId, exportMarketsActionId, documentsListActionId, BASE_URL } from '../../../utils/constants'
import { fill_action } from '../../../actions/fillCombo_action'
import { updateMemberRegistration_action, deleteRegistrationDocument_action, getMemberBuisnessRegistration_action, getIncompleteMemberBuisnessRegistration_action } from '../../../actions/staticAction/registration_action'
import $ from "jquery";
import moment from 'moment';
import { countDownDate_action } from '../../../actions/staticAction/static_action';

class BuisnessDetails extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            isOpen: false,
            MemberID: '',
            MembershipNo: '',
            AccountID: '',
            buisnessList: [],
            productsList: [],
            exportsList: [],
            annualRevenue: '',
            documentsList: [],
            docTypeList: [],
            GstNoErr: '',
            PanNoErr: '',
            gstValidationList: [],
            GstdocErr: '',
            PandocErr: '',
            docsErr: '',
            docDeleteID: '',
            primaryProduct: '',
            primaryProductsErr: '',
            buisnessListErr: '',
            otherBuisness: '',
            otherPrimaryProduct: '',
            otherBuisnessErr: '',
            otherPrimaryProductErr: '',
            //cms
            cmsSectionData: [], cmsMenuData: [], cmsFooterData: [],

            isFormSubmitted: false
        }
        this.getFillList = this.getFillList.bind(this);
        this.onBuisnessSelect = this.onBuisnessSelect.bind(this);
        this.onProductSelect = this.onProductSelect.bind(this);
        this.onExportsSelect = this.onExportsSelect.bind(this);
        this.onDocTypeSelect = this.onDocTypeSelect.bind(this);
        this.onDocNoEnter = this.onDocNoEnter.bind(this);
        this.onFilePick = this.onFilePick.bind(this);
        this.resizeFile = this.resizeFile.bind(this);
        this.onPdfSelect = this.onPdfSelect.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.getDetails = this.getDetails.bind(this);
        this.getIncompleteDetails = this.getIncompleteDetails.bind(this);
        this.onGSTchange = this.onGSTchange.bind(this);
        this.onCrossClick = this.onCrossClick.bind(this);
        this.handleDeleteDocument = this.handleDeleteDocument.bind(this);

    }

    async componentDidMount() {
        // const isTimeout = await this.getCountDownDate();
        // if (isTimeout) {
        //     this.props.navigate('/')
        // } else {
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        window.scrollTo(0, 0)
        sessionStorage.setItem("currentPage", 'buisnessDetails')
        this.getFillList(documentsListActionId, '', '', '', '').then(() => {
            this.getFillList(businessSectorActionId, '', '', '', '').then(() => {
                this.getFillList(exportMarketsActionId, '', '', '', '').then(() => {
                    this.getFillList(primaryServicesActionId, '', '', '', '').then(() => {
                        this.getFillList(gstValidationListActionId, '', '', '', '').then(() => {
                            setTimeout(() => {
                                if (this.props.location.pathname.includes("/buisnessDetails/")) {
                                    var code = this.props.location.pathname.replace("/buisnessDetails/", "")
                                    console.log('this.props.location.state', this.props.location.state, code)
                                    this.getIncompleteDetails(code)
                                    // this.loadscript();
                                } else if ((sessionStorage.getItem("MemberID") != null)) {
                                    this.getDetails()
                                    // this.loadscript();
                                } else {
                                    this.setState({ isLoading: false })
                                }
                            }, 200);
                        })
                    })
                })
            })
        })

    }

    getCountDownDate() {
        const { } = this.state
        this.setState({ isLoading: true })
        return this.props
            .countDownDate_action()
            .then((data) => {
                if (data.error != 1) {
                    if (data.data.length > 0) {
                        const LaunchDate = data.data[0]['countDownDate']
                        const targetDate = moment.utc(LaunchDate);
                        // Current date in UTC
                        const currentDate = moment();
                        const split = currentDate.format().split('+')
                        const updateCurrentDate = split[0] + 'Z'
                        const totalSeconds = targetDate.diff(updateCurrentDate, 'seconds');
                        return totalSeconds > 0;
                    }
                    this.setState({ isLoading: false })
                }
                this.setState({ isLoading: false });
                if (data.error == 1) toastError(data.data.ErrorMsg);
                return false;
            });
    }

    getDetails() {
        const { isLoading, countryList, companyName, companywebsite, industryId, yearOfEstablishment, companyAdd1, companyAdd2, city, regstate, countryId, contactPerson, designation, emailId, phone, sameAsCorrespondence, invcompanyName, invcompanywebsite, invindustryId, invyearOfEstablishment, invcompanyAdd1, invcompanyAdd2, invcity, invregstate, invcountryId, invcontactPerson, invdesignation, invemailId, invphone, prename, isOtherPreName, otherName, invisOtherPreName, invotherName, invprename, isOpenDropDownState, prephone, invprephone, focusedIndexState, isOpenDropDownCity, focusedIndexCity, tempStateList, tempCityList, stateList, cityList, companyNameErr, companywebsiteErr, industryIdErr, yearOfEstablishmentErr, companyAdd1Err, companyAdd2Err, cityErr, regstateErr, countryIdErr, contactPersonErr, designationErr, emailIdErr, phoneErr, invcompanyNameErr, invcompanywebsiteErr, invindustryIdErr, invyearOfEstablishmentErr, invcompanyAdd1Err, stateId, invcompanyAdd2Err, invcityErr, invregstateErr, invcountryIdErr, invcontactPersonErr, invdesignationErr, invemailIdErr, invphoneErr, MemberID, MembershipNo, productsList, primaryProduct, buisnessList, exportsList, namePrefix, AccountID } = this.state
        this.setState({ isLoading: true })
        this.props
            .getMemberBuisnessRegistration_action(AccountID, parseInt(sessionStorage.getItem("MemberID")))
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    // if (data.data[0][0].MembershipFormStatusID == 1) {
                    // } else {
                    // GST Document
                    if ((data.data[0][0]['GSTFilePath'] && data.data[0][0]['GSTFilePath'] !== '') || (data.data[0][0]['GSTNo'] && data.data[0][0]['GSTNo'] !== '')) {
                        let filePath = data.data[0][0]['GSTFilePath'] || '';
                        let array = filePath ? filePath.split("/") : [];
                        let FileName = array.length > 0 ? array[array.length - 1] : '';
                        for (let i = 0; i < this.state.docTypeList.length; i++) {
                            if (this.state.docTypeList[i].Code == 1) {
                                this.state.documentsList.push({
                                    docId: this.state.docTypeList[i].Code,
                                    fileName: FileName,
                                    fileType: '',
                                    filePath: filePath,
                                    file: FileName,
                                    no: data.data[0][0].GSTNo || '',
                                    type: this.state.docTypeList[i].Description
                                });
                            }
                        }
                    }

                    // PAN Document
                    if ((data.data[0][0]['PanCardFilePath'] && data.data[0][0]['PanCardFilePath'] !== '') || (data.data[0][0]['PanNo'] && data.data[0][0]['PanNo'] !== '')) {
                        let filePath = data.data[0][0]['PanCardFilePath'] || '';
                        let array = filePath ? filePath.split("/") : [];
                        let FileName = array.length > 0 ? array[array.length - 1] : '';
                        for (let i = 0; i < this.state.docTypeList.length; i++) {
                            if (this.state.docTypeList[i].Code == 2) {
                                this.state.documentsList.push({
                                    docId: this.state.docTypeList[i].Code,
                                    fileName: FileName,
                                    fileType: '',
                                    filePath: filePath,
                                    file: FileName,
                                    no: data.data[0][0].PanNo || '',
                                    type: this.state.docTypeList[i].Description
                                });
                            }
                        }
                    }

                    // Additional Document
                    if (data.data[0][0]['AdditionalDocumentFilePath'] && data.data[0][0]['AdditionalDocumentFilePath'] !== '') {
                        let filePath = data.data[0][0]['AdditionalDocumentFilePath'];
                        let array = filePath ? filePath.split("/") : [];
                        let FileName = array.length > 0 ? array[array.length - 1] : '';
                        for (let i = 0; i < this.state.docTypeList.length; i++) {
                            if (this.state.docTypeList[i].Code == 3) {
                                this.state.documentsList.push({
                                    docId: this.state.docTypeList[i].Code,
                                    fileName: FileName,
                                    fileType: '',
                                    filePath: filePath,
                                    file: FileName,
                                    no: '',
                                    type: this.state.docTypeList[i].Description
                                });
                            }
                        }
                    }

                    // }
                    if (this.state.documentsList.length == 0) {
                        if (parseInt(sessionStorage.getItem('countryId')) == 91) {
                            for (var i = 0; i < this.state.docTypeList.length; i++) {
                                console.log(this.state.docTypeList[i])
                                if (this.state.docTypeList[i].Code == 1 || this.state.docTypeList[i].Code == 2) {
                                    this.state.documentsList.push({
                                        docId: this.state.docTypeList[i].Code, fileName: '', fileType: '', filePath: '', file: '', no: '', type: this.state.docTypeList[i].Description
                                    })
                                }
                            }
                        }
                        else {
                            this.state.documentsList.push({
                                docId: '', fileName: '', fileType: '', filePath: '', file: '', no: '', type: ''
                            })
                        }
                    }
                    console.log(this.state.documentsList)

                    var buisnessListDetails = data.data[1].length > 0 ? data.data[1] : []
                    for (var i = 0; i < buisnessList.length; i++) {
                        for (var j = 0; j < buisnessListDetails.length; j++) {
                            if (buisnessList[i].Code == buisnessListDetails[j].BusinessSectorID) {
                                buisnessList[i].isSelect = true
                                if (buisnessList[i].Description == 'Others') {
                                    this.setState({ otherBuisness: data.data[0][0].OtherBusinessSector })
                                }
                            }
                        }
                    }
                    // var productsListDetails = data.data[2].length > 0 ? data.data[2] : []
                    // for (var i = 0; i < productsList.length; i++) {
                    //     for (var j = 0; j < productsListDetails.length; j++) {
                    //         if (productsList[i].Code == productsListDetails[j].PrimaryServicesID) {
                    //             productsList[i].isSelect = true
                    //             if (productsList[i].Code == 6) {
                    //                 this.setState({ otherPrimaryProduct: data.data[0][0].OtherPrimaryServices })
                    //             }
                    //         }
                    //     }
                    // }
                    var exportsListDetails = data.data[2].length > 0 ? data.data[2] : []
                    for (var i = 0; i < exportsList.length; i++) {
                        for (var j = 0; j < exportsListDetails.length; j++) {
                            if (exportsList[i].Code == exportsListDetails[j].ExportMarketsID) {
                                exportsList[i].isSelect = true
                            }
                        }
                    }
                    this.setState({
                        MemberID: data.data[0][0].MemberID,
                        MembershipNo: data.data[0][0].MembershipNo,
                        annualRevenue: data.data[0][0].AnnualRevenue,
                        exportsList: exportsList,
                        productsList: productsList,
                        buisnessList: buisnessList,
                        documentsList: this.state.documentsList,
                        primaryProduct: data.data[0][0].PrimaryServices
                    }, () => {
                        this.setState({ isLoading: false })
                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }

    getIncompleteDetails(code) {
        const { isLoading, countryList, companyName, companywebsite, industryId, yearOfEstablishment, companyAdd1, companyAdd2, city, regstate, countryId, contactPerson, designation, emailId, phone, sameAsCorrespondence, invcompanyName, invcompanywebsite, invindustryId, invyearOfEstablishment, invcompanyAdd1, invcompanyAdd2, invcity, invregstate, invcountryId, invcontactPerson, invdesignation, invemailId, invphone, prename, isOtherPreName, otherName, invisOtherPreName, invotherName, invprename, isOpenDropDownState, prephone, invprephone, focusedIndexState, isOpenDropDownCity, focusedIndexCity, tempStateList, tempCityList, stateList, cityList, companyNameErr, companywebsiteErr, industryIdErr, yearOfEstablishmentErr, companyAdd1Err, companyAdd2Err, cityErr, regstateErr, countryIdErr, contactPersonErr, designationErr, emailIdErr, phoneErr, invcompanyNameErr, invcompanywebsiteErr, invindustryIdErr, invyearOfEstablishmentErr, invcompanyAdd1Err, stateId, invcompanyAdd2Err, invcityErr, invregstateErr, invcountryIdErr, invcontactPersonErr, invdesignationErr, invemailIdErr, invphoneErr, MemberID, MembershipNo, namePrefix, buisnessList, exportsList, productsList, AccountID } = this.state
        this.setState({ isLoading: true })
        this.props
            .getIncompleteMemberBuisnessRegistration_action(AccountID, code)
            .then((data) => {
                console.log(data)
                if (data.error != 1) {
                    console.log(this.state.documentsList)
                    sessionStorage.setItem('countryId', data.data?.[0]?.[0]?.CountryID)
                    if (data.data[0][0].MembershipFormStatusID == 3 && data.data[0][0].MembershipStatusID == 2) {
                        this.setState({ isLoading: false, isOpen: false, isFormSubmitted: true })
                        return
                    }
                    if (data.data[0][0].MembershipFormStatusID == 1) {
                        if (parseInt(data.data?.[0]?.[0]?.CountryID) == 91) {
                            for (var i = 0; i < this.state.docTypeList.length; i++) {
                                console.log(this.state.docTypeList[i])
                                if (this.state.docTypeList[i].Code == 1 || this.state.docTypeList[i].Code == 2) {
                                    this.state.documentsList.push({
                                        docId: this.state.docTypeList[i].Code, fileName: '', fileType: '', filePath: '', file: '', no: '', type: this.state.docTypeList[i].Description
                                    })
                                }
                            }
                        }
                        else {
                            this.state.documentsList.push({
                                docId: '', fileName: '', fileType: '', filePath: '', file: '', no: '', type: ''
                            })
                        }
                    } else {
                        if (data.data[0][0]['GSTFilePath'] != null && data.data[0][0]['GSTFilePath'] != '') {
                            var FileName = ''
                            var filePath = data.data[0][0]['GSTFilePath'] != null && data.data[0][0]['GSTFilePath'] != '' ? data.data[0][0]['GSTFilePath'] : ''
                            var array = data.data[0][0]['GSTFilePath'] != null && data.data[0][0]['GSTFilePath'] != "" ? filePath.split("/") : []
                            FileName = array.length > 0 ? array[array.length - 1] : ''
                            for (var i = 0; i < this.state.docTypeList.length; i++) {
                                console.log(this.state.docTypeList[i])
                                if (this.state.docTypeList[i].Code == 1) {
                                    this.state.documentsList.push({
                                        docId: this.state.docTypeList[i].Code, fileName: FileName, fileType: '', filePath: filePath, file: FileName, no: data.data[0][0].GSTNo, type: this.state.docTypeList[i].Description
                                    })
                                }
                            }
                        }
                        if (data.data[0][0]['PanCardFilePath'] != null && data.data[0][0]['PanCardFilePath'] != '') {
                            var FileName = ''
                            var filePath = data.data[0][0]['PanCardFilePath'] != null && data.data[0][0]['PanCardFilePath'] != '' ? data.data[0][0]['PanCardFilePath'] : ''
                            var array = data.data[0][0]['PanCardFilePath'] != null && data.data[0][0]['PanCardFilePath'] != "" ? filePath.split("/") : []
                            FileName = array.length > 0 ? array[array.length - 1] : ''
                            for (var i = 0; i < this.state.docTypeList.length; i++) {
                                console.log(this.state.docTypeList[i])
                                if (this.state.docTypeList[i].Code == 2) {
                                    this.state.documentsList.push({
                                        docId: this.state.docTypeList[i].Code, fileName: FileName, fileType: '', filePath: filePath, file: FileName, no: data.data[0][0].PanNo, type: this.state.docTypeList[i].Description
                                    })
                                }
                            }
                        }
                        if (data.data[0][0]['AdditionalDocumentFilePath'] != null && data.data[0][0]['AdditionalDocumentFilePath'] != '') {
                            var FileName = ''
                            var filePath = data.data[0][0]['AdditionalDocumentFilePath'] != null && data.data[0][0]['AdditionalDocumentFilePath'] != '' ? data.data[0][0]['AdditionalDocumentFilePath'] : ''
                            var array = data.data[0][0]['AdditionalDocumentFilePath'] != null && data.data[0][0]['AdditionalDocumentFilePath'] != "" ? filePath.split("/") : []
                            FileName = array.length > 0 ? array[array.length - 1] : ''
                            for (var i = 0; i < this.state.docTypeList.length; i++) {
                                console.log(this.state.docTypeList[i])
                                if (this.state.docTypeList[i].Code == 3) {
                                    this.state.documentsList.push({
                                        docId: this.state.docTypeList[i].Code, fileName: FileName, fileType: '', filePath: filePath, file: FileName, no: '', type: this.state.docTypeList[i].Description
                                    })
                                }
                            }
                        }
                    }

                    var buisnessListDetails = data.data[1].length > 0 ? data.data[1] : []
                    for (var i = 0; i < buisnessList.length; i++) {
                        for (var j = 0; j < buisnessListDetails.length; j++) {
                            if (buisnessList[i].Code == buisnessListDetails[j].BusinessSectorID) {
                                buisnessList[i].isSelect = true
                                if (buisnessList[i].Description == "Others") {
                                    this.setState({ otherBuisness: data.data[0][0].OtherBusinessSector })
                                }
                            }
                        }
                    }
                    // var productsListDetails = data.data[2].length > 0 ? data.data[2] : []
                    // for (var i = 0; i < productsList.length; i++) {
                    //     for (var j = 0; j < productsListDetails.length; j++) {
                    //         if (productsList[i].Code == productsListDetails[j].PrimaryServicesID) {
                    //             productsList[i].isSelect = true
                    //         }
                    //     }
                    // }
                    var exportsListDetails = data.data[3].length > 0 ? data.data[3] : []
                    for (var i = 0; i < exportsList.length; i++) {
                        for (var j = 0; j < exportsListDetails.length; j++) {
                            if (exportsList[i].Code == exportsListDetails[j].ExportMarketsID) {
                                exportsList[i].isSelect = true
                            }
                        }
                    }
                    this.setState({
                        MemberID: data.data[0][0].MemberID,
                        MembershipNo: data.data[0][0].MembershipNo,
                        annualRevenue: data.data[0][0].AnnualRevenue,
                        primaryProduct: data.data[0][0].PrimaryServices,
                        exportsList: exportsList,
                        productsList: productsList,
                        buisnessList: buisnessList,
                        documentsList: this.state.documentsList
                    }, () => {
                        this.setState({ isLoading: false })

                    })
                } else {
                    this.setState({ isLoading: false })
                    toastError(data.data.ErrorMsg);
                }
            })
    }

    handlePrevious() {
        const { MemberID } = this.state
        sessionStorage.setItem('MemberID',MemberID)
        this.props.navigate('/companyProfile', { state: { isOpen: false } })
        sessionStorage.setItem("currentPage", 'companyProfile')
    }

    handleNext() {
        const {
            isLoading,
            buisnessList,
            productsList,
            otherBuisness,
            otherPrimaryProduct,
            exportsList,
            annualRevenue,
            documentsList,
            docTypeList,
            MemberID,
            primaryProduct
        } = this.state;

        this.inputValidation().then(res => {
            if (!res) {
                this.setState({ isLoading: true });

                let GSTno = '';
                let PANno = '';

                const docs = Array.isArray(documentsList) ? documentsList : [];

                docs.forEach(doc => {
                    if (doc.docId === 1 && doc.no) {
                        GSTno = doc.no;
                    }
                    if (doc.docId === 2 && doc.no) {
                        PANno = doc.no;
                    }
                });

                const finalbuisnessList = buisnessList
                    .filter(b => b.isSelect)
                    .map(b => ({ BuisnessSectorID: b.Code }));

                const finalproductsList = productsList
                    .filter(p => p.isSelect)
                    .map(p => ({ PrimaryServicesID: p.Code }));

                const finalexportsList = exportsList
                    .filter(e => e.isSelect)
                    .map(e => ({ ExportMarketsID: e.Code }));

                this.props
                    .updateMemberRegistration_action(
                        MemberID,
                        GSTno,
                        PANno,
                        finalbuisnessList,
                        finalexportsList,
                        finalproductsList,
                        annualRevenue,
                        docs,
                        otherBuisness,
                        otherPrimaryProduct,
                        primaryProduct
                    )
                    .then((data) => {
                        if (data.error !== 1) {
                            this.props.navigate('/payment');
                            sessionStorage.setItem('MemberID', MemberID)
                            sessionStorage.setItem("currentPage", 'payment');
                        } else {
                            this.setState({ isLoading: false });
                            toastError(data.msg);
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        this.setState({ isLoading: false });
                        toastError("An error occurred during submission.");
                    });
            } else {
                toastError("Please enter mandatory fields");
            }
        });
    }

    inputValidation() {
        const { isLoading, buisnessList, otherBuisness, otherBuisnessErr, otherPrimaryProduct, otherPrimaryProductErr, GstNoErr, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        var Err = false
        console.log()
        return new Promise((resolve, reject) => {
            //gst and pan validation start
            if (parseInt(sessionStorage.getItem('countryId')) == 91) {
                for (var i = 0; i < this.state.documentsList.length; i++) {
                    if (this.state.documentsList[i].no == '' || this.state.documentsList[i].no == null) {
                        if (this.state.documentsList[i].docId == 1) {
                            this.setState({ GstNoErr: 'Please enter GST no.' })
                        }
                        if (this.state.documentsList[i].docId == 2) {
                            this.setState({ PanNoErr: 'Please enter PAN no.' })
                        }
                        Err = true
                    }
                    // if (this.state.documentsList[i].file == '' || this.state.documentsList[i].file == null) {
                    //     if (this.state.documentsList[i].docId == 1) {
                    //         this.setState({ GstdocErr: 'Please upload GST document' })
                    //     }
                    //     if (this.state.documentsList[i].docId == 2) {
                    //         this.setState({ PandocErr: 'Please upload PAN document' })
                    //     }
                    //     Err = true
                    // }
                }
            }
            //gst and pan validation end
            var ppNoErr = false

            // for (var i = 0; i < this.state.productsList.length; i++) {
            //     if (this.state.productsList[i].isSelect) {
            //         ppNoErr = true
            //     }
            // }
            if (this.state.primaryProduct == '' || this.state.primaryProduct == null) {
                this.setState({
                    primaryProductsErr: 'Please enter Primary product/service'
                })
                Err = true
            }
            var buissnessNoErr = false
            for (var i = 0; i < this.state.buisnessList.length; i++) {
                if (this.state.buisnessList[i].isSelect) {
                    buissnessNoErr = true
                }
            }
            // if (!ppNoErr) {
            //     this.setState({ primaryProductsErr: 'Please select atleast one Primary Products/Services' })
            //     Err = true
            // }
            if (!buissnessNoErr) {
                this.setState({ buisnessListErr: 'Please select atleast one Buisness' })
                Err = true
            }
            if (GstNoErr != '' && GstNoErr != null) {
                Err = true
            }
            for (var i = 1; i < buisnessList.length; i++) {
                if (buisnessList[i].Description == "Others" && buisnessList[i].isSelect) {
                    if (otherBuisness.trim() == '') {
                        Err = true
                        this.setState({ otherBuisnessErr: 'Enter Other Buisness' })
                    }
                }
            }
            // for (var i = 1; i < productsList.length; i++) {
            //     if (productsList[i].Code == 6 && productsList[i].isSelect) {
            //         if (otherPrimaryProduct.trim() == '') {
            //             Err = true
            //             this.setState({ otherPrimaryProductErr: 'Enter Other Primary product' })
            //         }
            //     }
            // }
            //add products validation
            resolve(Err)
        })
    }

    getFillList(actionID, ModuleID, KeyValue, Value, UserID) {
        this.setState({ isLoading: true })
        return new Promise((resolve, reject) => {
            this.props
                .fill_action(actionID, ModuleID, KeyValue, Value, UserID)
                .then((data) => {
                    if (data.error != 1) {
                        if (actionID === businessSectorActionId) {
                            data.data.length > 0 && data.data.forEach(item => {
                                item.isSelect = false
                            })
                            this.setState({ buisnessList: data.data }, () =>
                                console.log(data.data),
                                resolve(true)
                            )
                        }
                        if (actionID === exportMarketsActionId) {
                            data.data.length > 0 && data.data.forEach(item => {
                                item.isSelect = false
                            })
                            this.setState({
                                exportsList: data.data,
                            }, () =>
                                resolve(true)
                            )
                        }
                        if (actionID === gstValidationListActionId) {
                            this.setState({
                                gstValidationList: data.data,
                            }, () =>
                                resolve(true)
                            )
                        }
                        if (actionID === primaryServicesActionId) {
                            data.data.length > 0 && data.data.forEach(item => {
                                item.isSelect = false
                            })
                            this.setState({
                                productsList: data.data,
                            }, () =>
                                resolve(true)
                            )
                        }
                        if (actionID === documentsListActionId) {
                            console.log(data.data)
                            this.setState({ docTypeList: data.data }, () =>
                                resolve(true)
                            )
                        }
                    }
                })
        })
    }

    onGSTchange(value) {
        const { gstValidationList } = this.state
        var stateId = parseInt(sessionStorage.getItem('stateId'))
        var code = value
        if (code.length >= 2) {
            var code = value.slice(0, 2)
            console.log(code.length, gstValidationList, 'rere', parseInt(sessionStorage.getItem('stateId')))
            for (var i = 0; i < gstValidationList.length; i++) {
                if (gstValidationList[i].StateID == stateId) {
                    const errMsg = gstNoValidator(value)
                    console.log("errMsg-->", errMsg)
                    if (errMsg != '') {
                        this.setState({
                            GstNoErr: "Please enter proper gst no",
                            // compInfoGstNo: ''
                        });
                    } else if (parseInt(gstValidationList[i].GSTCode) != code) {
                        console.log("2--->",)
                        this.setState({
                            GstNoErr: "Please enter proper gst no",
                            // compInfoGstNo: ''
                        });
                    } else {
                        this.setState({
                            // compInfoGstNo: value,
                            GstNoErr: ''
                        })
                    }
                }
                // else {
                //     this.setState({
                //         compInfoGstNo: value,
                //     });
                // }
                // console.log(code, gstValidationList[i].StateID, stateId, parseInt(gstValidationList[i].GSTCode))
            }
        }
        // else {
        //     this.setState({
        //         compInfoGstNo: value,
        //     });
        // }
        return
    }

    onBuisnessSelect(id) {
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        console.log(id)
        for (var i = 0; i < buisnessList.length; i++) {
            if (buisnessList[i].Code == id) {
                if (buisnessList[i].isSelect) {
                    buisnessList[i].isSelect = false
                } else {
                    buisnessList[i].isSelect = true
                }
            }
        }
        this.setState({ buisnessList: buisnessList, buisnessListErr: '' })
    }


    onProductSelect(id) {
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        console.log(id)
        for (var i = 0; i < productsList.length; i++) {
            if (productsList[i].Code == id) {
                if (productsList[i].isSelect) {
                    productsList[i].isSelect = false
                } else {
                    productsList[i].isSelect = true
                }
            }
        }
        this.setState({ productsList: productsList, primaryProductsErr: '' })
    }

    onExportsSelect(id) {
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        console.log(id)
        for (var i = 0; i < exportsList.length; i++) {
            if (exportsList[i].Code == id) {
                if (exportsList[i].isSelect) {
                    exportsList[i].isSelect = false
                } else {
                    exportsList[i].isSelect = true
                }
            }
        }
        this.setState({ exportsList: exportsList })
    }

    onDocTypeSelect(id, Code) {
        console.log(Code)
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        for (var j = 0; j < docTypeList.length; j++) {
            if (docTypeList[j].Code == Code) {
                documentsList[id].docId = Code
                documentsList[id].type = docTypeList[j].Description
            }
        }
        this.setState({ documentsList: documentsList }, () => {
            console.log(documentsList)
        })
    }

    onDocNoEnter(id, value, docId) {
        console.log(value)
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        if (docId == 1) {
            this.onGSTchange(value)
        }
        if (docId == 2) {
            const errMsg = panNoValidator(value)
            console.log(errMsg)
            if (errMsg != '') {
                this.setState({
                    PanNoErr: errMsg,
                })
            } else {
                this.setState({
                    PanNoErr: "",
                })
            }
        }
        for (var i = 0; i < documentsList.length; i++) {
            if (i == id) {
                documentsList[i].no = value.toUpperCase()
            }
        }
        this.setState({ documentsList: documentsList }, () => {
        })
    }

    // On File Pick
    onFilePick = async (e, file, id, docId) => {
        e.preventDefault()
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, documentsList, docTypeList } = this.state
        console.log("File01010101------", file)
        if (file.length != 0) {
            if (file[0]['size'] >= 5 * 1024 * 1024) {
                toastError('File size more than 5mb are not allow.')
            } else {
                var image = '';
                if (file[0]['name'].toString().toLowerCase().includes('.pdf') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpeg') ||
                    file[0]['name'].toString().toLowerCase().includes('.png') ||
                    file[0]['name'].toString().toLowerCase().includes('.jpg')
                ) {
                    if (file[0]['name'].toString().toLowerCase().trim().includes('.jpg') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.png') ||
                        file[0]['name'].toString().toLowerCase().trim().includes('.jpeg')
                    ) {
                        image = await this.resizeFile(file[0]);
                        for (var i = 0; i < documentsList.length; i++) {
                            if (i == id) {
                                documentsList[i].file = image
                                documentsList[i].fileName = file[0]['name'].toString()
                            }
                        }
                        this.setState({ documentsList: documentsList })

                    }
                    else if (file[0]['name'].toString().toLowerCase().trim().includes('.pdf')) {
                        image = await this.onPdfSelect(file[0]);
                        for (var i = 0; i < documentsList.length; i++) {
                            if (i == id) {
                                documentsList[i].file = image
                                documentsList[i].fileName = file[0]['name'].toString()
                            }
                        }
                        this.setState({ documentsList: documentsList })
                    }
                    var fileType = file[0]['type']
                    var fileTypeList;
                    if (fileType.includes("/")) {
                        fileTypeList = fileType.split("/")
                    }
                    for (var i = 0; i < documentsList.length; i++) {
                        if (i == id) {
                            documentsList[i].fileType = fileTypeList.length > 0 ? fileTypeList[1] : ""
                        }
                    }
                    this.setState({ documentsList: documentsList })
                    if (docId == 1) {
                        this.setState({ GstdocErr: '' })
                    } else if (docId == 2) {
                        this.setState({ PandocErr: '' })
                    }
                } else {
                    toastError('Only .pdf , .jpeg, .png, .jpg files are allowed')
                    for (var i = 0; i < documentsList.length; i++) {
                        if (i == id) {
                            documentsList[i].file = ''
                            documentsList[i].fileType = ''
                            documentsList[i].fileName = ''
                            documentsList[i].filePath = ''
                            document.getElementById(`file${id}`).value = ""
                        }
                    }
                }
            }
        }
    }

    // If Pdf is selected in file
    onPdfSelect = (file) =>
        new Promise((resolve) => {
            let base64;
            let fileReader = new FileReader();
            fileReader.onload = function (fileLoadedEvent) {
                base64 = fileLoadedEvent.target.result;
                resolve(base64);
            };
            fileReader.readAsDataURL(file);
        });

    // File resize
    resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(file, 500, 600, 'JPEG', 80, 0,
                (uri) => {
                    resolve(uri);
                }, "base64", 300, 300,);
        });

    onAddRow() {
        this.state.documentsList.push({
            docId: '', fileName: '', fileType: '', filePath: '', file: '', no: '', type: ''
        })
        this.setState({ documentsList: this.state.documentsList })
    }
    onDelRow(i) {
        this.state.documentsList.splice(i, 1)
        this.setState({ documentsList: this.state.documentsList })
    }

    openImageInNewWindow = (imageData) => {
        // Open a new window
        // console.log(imageData)
        // setTimeout(() => {

        //     const newWindow = window.open('', '', 'width=600,height=400');

        //     // Write the image tag to the new window
        //     newWindow.document.write('<html><head><title>Image</title></head><body>');
        //     newWindow.document.write('<img src="' + imageData + '" alt="Image" />');
        //     newWindow.document.write('</body></html>');

        //     // Close the document write stream
        //     newWindow.document.close();
        // }, 1000);
        // Open a new window
        const newWindow = window.open('', '_blank');

        // If the new window was successfully opened
        if (newWindow) {
            // Set the content of the new window to display the image
            if (imageData.startsWith('data:image')) {
                newWindow.document.write(`
              <html>
                <head>
                  <title>Image</title>
                  <style>
                    body {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                      height: 100vh;
                      margin: 0;
                      background-color: #000;
                    }
                    img {
                      max-width: 100%;
                      max-height: 100%;
                      object-fit: contain;
                    }
                  </style>
                </head>
                <body>
                  <img src="${imageData}" alt="Image" />
                </body>
              </html>
            `);
            } else if (imageData.startsWith('data:application/pdf')) {
                // For PDFs: Embed the PDF
                newWindow.document.write(`
                  <html>
                    <head>
                      <title>PDF</title>
                    </head>
                    <body>
                      <embed src="${imageData}" width="100%" height="100%" type="application/pdf" />
                    </body>
                  </html>
                `);
            }
            newWindow.focus();

        } else {
            alert('Unable to open a new window. Please check your browser settings.');
        }

    };


    handleDeleteDocument(e) {
        e.preventDefault()
        const { isLoading, buisnessList, productsList, exportsList, annualRevenue, docDeleteID, documentsList, MemberID, docTypeList } = this.state
        this.setState({ isLoading: true })
        this.props.deleteRegistrationDocument_action(MemberID, docDeleteID)
            .then((data) => {
                if (data.error != 1) {
                    toastSuccess("Document Deleted SuccessFully")
                    // sessionStorage.getItem('VisitorTypeID') == 1 && this.setState({ passportFile: "", passPortFileName: "", isPassportFilePresent: false })
                    for (var i = 0; i < documentsList.length; i++) {
                        if (documentsList[i].docId == docDeleteID) {
                            documentsList[i].file = ''
                            documentsList[i].fileType = ''
                            documentsList[i].fileName = ''
                            documentsList[i].filePath = ''
                        }
                    }
                    this.setState({ isLoading: false, documentsList: documentsList, isOpen: false })
                    // sessionStorage.getItem('VisitorTypeID') == 2 && this.setState({ visitorGroupList: visitorGroupList })
                    // this.getVisitorRegistrationDetails()
                } else {
                    toastError(data.msg)
                    this.setState({ isLoading: false })
                }
            }).catch((error) => {
                console.log(error)
            })
    }

    onCrossClick(id) {
        console.log('id', id)
        this.setState({
            docDeleteID: id, isOpen: true
        })
    }

    render() {
        const { isLoading, isFormSubmitted, isOpen, buisnessList, productsList, exportsList, annualRevenue, otherBuisness, otherPrimaryProduct, documentsList, docTypeList } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader />
                ) : isFormSubmitted ? (
                    <Modal show={isFormSubmitted} style={{ backdropFilter: 'blur(1px)' }} size="md">
                        <Modal.Body  >
                            <h5 className="modal-title py-2 fw-normal" id="staticBackdropLabel" >
                                Form Already Submitted
                            </h5>

                        </Modal.Body>

                        <Modal.Footer style={{ justifyContent: 'right', padding: '5px 10px' }}>

                            <button type='btn' className='btn btn-outline-primary px-4'
                                onClick={() => this.props.navigate('/')}
                                data-toggle="modal"
                                data-target="#add_comment_modal"
                            >  Ok</button>

                        </Modal.Footer>
                    </Modal>
                ) : <>
                    {/* <ToastContainer />. */}
                    <Header />
                    <ToastContainer />
                    <section class="registration_form">
                        <div class="container">

                            <div class="row mt-15">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-body custom_form_fields pt-3">

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="md-stepper-horizontal orange">
                                                        <div class="md-step " id="first_div">
                                                            <div class="md-step-circle"><span>1</span></div>
                                                            <div class="md-step-title">Company Profile</div>
                                                            <div class="md-step-bar-left"></div>
                                                            <div class="md-step-bar-right"></div>
                                                        </div>
                                                        <div class="md-step active" id="second_div">
                                                            <div class="md-step-circle"><span>2</span></div>
                                                            <div class="md-step-title">Business Details</div>
                                                            <div class="md-step-bar-left"></div>
                                                            <div class="md-step-bar-right"></div>
                                                        </div>
                                                        <div class="md-step" id="third_div">
                                                            <div class="md-step-circle"><span>3</span></div>
                                                            <div class="md-step-title">Payment</div>
                                                            <div class="md-step-bar-left"></div>
                                                            <div class="md-step-bar-right"></div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div class="row">
                                                <div class="col-md-12">
                                                    <div class="custom_tabs" id="mytabs">
                                                        <div class="tab-content">
                                                            <div class="tab-pane active" id="Business_Details_and_Industry_segments_tab" role="tabpanel" aria-labelledby="Business_Details_and_Industry_segments_tab" tabindex="0">

                                                                <div class="row">
                                                                    <div class="col-md-12">
                                                                        <div class="row">
                                                                            <div class="col-md-12">
                                                                                <fieldset>
                                                                                    <legend>Business Sector<span className="red-star text-danger">*</span></legend>
                                                                                    <div class="business_sector_grid">
                                                                                        {buisnessList.length > 0 && buisnessList.map(item => (
                                                                                            <div class="form-group">
                                                                                                <div class="custom-control custom-checkbox" onClick={(e) => this.onBuisnessSelect(item.Code)} >
                                                                                                    <input type="checkbox" class="custom-control-input" checked={item.isSelect} value={item.isSelect} />
                                                                                                    <label class="custom-control-label" >{item.Description}</label>
                                                                                                </div>
                                                                                                {(item.Description == 'Others' && item.isSelect) && <input value={otherBuisness} type="text" class="form-control" placeholder="Other*" maxLength={200} onChange={(e) => this.setState({ otherBuisness: e.target.value, otherBuisnessErr: '' })} />}
                                                                                                {(item.Description == 'Others' && item.isSelect) && <span className='text-danger text-start text-left d-block'>{this.state.otherBuisnessErr}</span>}
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>
                                                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.buisnessListErr}</span>}
                                                                                </fieldset>
                                                                            </div>
                                                                        </div>

                                                                        {/* <div class="row">
                                                                        <div class="col-md-12">
                                                                            <fieldset>
                                                                                <legend>Primary Products/Services<span className="red-star text-danger">*</span></legend>

                                                                                <div class="business_sector_grid">
                                                                                    {productsList.length > 0 && productsList.map(item => (
                                                                                        <div class="form-group">
                                                                                            <div class="custom-control custom-checkbox" onClick={(e) => this.onProductSelect(item.Code)} >
                                                                                                <input type="checkbox" class="custom-control-input" checked={item.isSelect} value={item.isSelect} />
                                                                                                <label class="custom-control-label" >{item.Description}</label>
                                                                                            </div>
                                                                                            {(item.Code == 6 && item.isSelect) && <input value={otherPrimaryProduct} type="text" class="form-control" placeholder="Other*" maxLength={200} onChange={(e) => this.setState({ otherPrimaryProduct: e.target.value, otherPrimaryProductErr: '' })} />}
                                                                                            {(item.Code == 6 && item.isSelect) && <span className='text-danger text-start text-left d-block'>{this.state.otherPrimaryProductErr}</span>}
                                                                                        </div>
                                                                                    ))}

                                                                                </div>
                                                                                {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.primaryProductsErr}</span>}
                                                                            </fieldset>
                                                                        </div>
                                                                    </div> */}

                                                                        <div class="row">
                                                                            <div class="col-md-12">
                                                                                <fieldset>
                                                                                    <legend>Key Export Markets</legend>

                                                                                    <div class="business_sector_grid">
                                                                                        {exportsList.length > 0 && exportsList.map(item => (
                                                                                            <div class="form-group">
                                                                                                <div class="custom-control custom-checkbox" onClick={(e) => this.onExportsSelect(item.Code)} >
                                                                                                    <input type="checkbox" class="custom-control-input" checked={item.isSelect} value={item.isSelect} />
                                                                                                    <label class="custom-control-label" >{item.Description}</label>
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </div>

                                                                                </fieldset>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row">
                                                                            <div class="col-md-12">
                                                                                <div class="form-group">
                                                                                    <label>Primary Products/Services<span className="red-star text-danger">*</span></label>
                                                                                    <input value={this.state.primaryProduct} type="text" class="form-control" placeholder="Enter Primary Products/Services" maxLength={200} onChange={(e) => this.setState({ primaryProduct: e.target.value, primaryProductsErr: '' })} />
                                                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.primaryProductsErr}</span>}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row">
                                                                            <div class="col-md-12">
                                                                                <div class="form-group">
                                                                                    <label>Annual Revenue</label>
                                                                                    <input value={annualRevenue} type="text" class="form-control" placeholder="Enter Annual Revenue" maxLength={20} onChange={(e) => this.setState({ annualRevenue: e.target.value })} />
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        {parseInt(sessionStorage.getItem('countryId')) == 91 && <div class="row mt-3">
                                                                            <div class="col-md-12">
                                                                                <div class="form-group">
                                                                                    <label class="floating-label">Upload Documents
                                                                                        {/* {parseInt(sessionStorage.getItem('countryId')) == 91 && <span className="red-star text-danger">*</span>} */}
                                                                                        (Maximum 5mb / File Type .jpg, .jpeg, .png, .pdf)</label>
                                                                                    {
                                                                                        documentsList.length > 0 && documentsList.map((item, index) => (
                                                                                            <div class="after-add-more2">
                                                                                                <div class="Add_more_div">
                                                                                                    <div class="select_doc_type">
                                                                                                        <select onChange={(e) => this.onDocTypeSelect(index, e.target.value)} value={item.docId} class="form-control customSelect floating-control select2" id="fin_details_doc_upload" disabled={parseInt(sessionStorage.getItem('countryId')) == 91}>
                                                                                                            <option value="Select">Select Document Type</option>
                                                                                                            {docTypeList.length > 0 && docTypeList.map(element => (
                                                                                                                <option value={element.Code}>{element.Description}</option>
                                                                                                            ))}
                                                                                                        </select>
                                                                                                    </div>
                                                                                                    {(item.docId != 3 && item.docId != '') && <div class="img_upload_div">
                                                                                                        <input type='text' onChange={(e) => this.onDocNoEnter(index, e.target.value, item.docId)} class="form-control" value={item.no} placeholder={`${item.type}*`} />
                                                                                                        {item.docId == 1 && <span className='text-danger text-start text-left d-block  ml-2'>{this.state.GstNoErr}</span>}
                                                                                                        {item.docId == 2 && <span className='text-danger text-start text-left d-block  ml-2'>{this.state.PanNoErr}</span>}
                                                                                                    </div>}
                                                                                                    {(item.filePath == '' || item.filePath == null) ? <div class="img_upload_div">
                                                                                                        <input type='file' onChange={(e) => this.onFilePick(e, e.target.files, index, item.docId)} class="form-control" id={`file${index}`} accept=".jpg, .jpeg, .png, .pdf" />
                                                                                                        {item.docId == 1 && <span className='text-danger text-start text-left d-block  ml-2'>{this.state.GstdocErr}</span>}
                                                                                                        {item.docId == 2 && <span className='text-danger text-start text-left d-block  ml-2'>{this.state.PandocErr}</span>}
                                                                                                    </div> :
                                                                                                        <div style={{
                                                                                                            border: '1px solid #ccc',
                                                                                                            padding: '2px 20px',
                                                                                                            // display: 'inline-flex',
                                                                                                            alignItems: 'center',
                                                                                                            marginRight: '12px',
                                                                                                            maxWidth: '300px',
                                                                                                            height: '33px'
                                                                                                        }}>
                                                                                                            <span style={{ marginRight: '10px' }}
                                                                                                            >{item.fileName}</span>
                                                                                                            <i className="fa fa-times text-danger img-can"
                                                                                                                onClick={() => this.onCrossClick(item.docId)}
                                                                                                            ></i>
                                                                                                            {item.docId == 1 && <span className='text-danger text-start text-left d-block  ml-2'>{this.state.GstdocErr}</span>}
                                                                                                            {item.docId == 2 && <span className='text-danger text-start text-left d-block  ml-2'>{this.state.PandocErr}</span>}
                                                                                                        </div>
                                                                                                    }
                                                                                                    {item.filePath != '' || item.file != '' ? <div class="preview_icon_div" >
                                                                                                        {item.fileType != null && item.fileType != '' ? <a
                                                                                                            // href={item.filePath}
                                                                                                            // target="_blank"
                                                                                                            // rel="noopener noreferrer"
                                                                                                            onClick={() => this.openImageInNewWindow(`${item.file}`)}
                                                                                                            class="preview load_document_icon" title="View"><i class="fa fa-eye"></i></a> :
                                                                                                            <a
                                                                                                                href={item.filePath}
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                                class="preview load_document_icon" title="View"><i class="fa fa-eye"></i></a>}
                                                                                                    </div> : ''}
                                                                                                    {console.log(item.file, 'item.file', item.filePath)}
                                                                                                    {(parseInt(sessionStorage.getItem('countryId')) != 91) && (index == 0 ? (documentsList.length <= 2 && <div class="plus_icon_div change2">
                                                                                                        <button class="add-more2 load_document_icon" onClick={() => this.onAddRow()}>
                                                                                                            <i class="fa fa-plus"></i>
                                                                                                        </button>
                                                                                                    </div>) :
                                                                                                        <div class="plus_icon_div change2">
                                                                                                            <button class="action_btn remove2 fa fa-trash" onClick={() => this.onDelRow(index)}>
                                                                                                            </button>
                                                                                                        </div>)}
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    {<span className='text-danger text-start text-left d-block  ml-2'>{this.state.docsErr}</span>}

                                                                                </div>
                                                                            </div>
                                                                        </div>}

                                                                        <div class="row">
                                                                            <div class="col-md-6 text-left">
                                                                                <button class="btn btn-primary previous_btn" onClick={() => this.handlePrevious()}>
                                                                                    Previous
                                                                                </button>
                                                                            </div>
                                                                            <div class="col-md-6 text-right">
                                                                                <button class="btn btn-primary next_btn" onClick={() => this.handleNext()}>
                                                                                    Next
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <Modal show={isOpen} onHide={() => this.setState({ isOpen: false })}>
                        <Modal.Header closeButton>
                            <Modal.Title>Confirm Delete</Modal.Title>
                        </Modal.Header>
                        <Modal.Body><p class="pop_label">Do you really want to delete this Document?</p></Modal.Body>
                        <Modal.Footer>
                            <button type="button" class="btn btn-del-pop"
                                onClick={(e) => this.handleDeleteDocument(e)}
                            >Yes</button>
                            <button type="button" class="btn btn-can-pop" data-dismiss="modal" style={{ marginLeft: '5px' }} onClick={() => this.setState({ isOpen: false, docDeleteID: '' })}>No</button>
                        </Modal.Footer>
                    </Modal>
                    <Footer />
                </>}
            </>)
    }
}

export default withRouter(connect(null, {
    fill_action, updateMemberRegistration_action, getIncompleteMemberBuisnessRegistration_action,
    deleteRegistrationDocument_action, getMemberBuisnessRegistration_action, countDownDate_action,
})(BuisnessDetails));
